import { render, staticRenderFns } from "./FieldConfiguratorCategories.vue?vue&type=template&id=82361f4e&"
import script from "./FieldConfiguratorCategories.vue?vue&type=script&lang=js&"
export * from "./FieldConfiguratorCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports